import editProportion from '@/core/components/editProportion'
import store from '@/store'
export default {
  // 型号含量
  className: 'shopManagement',
  fields: [
    'name',
    'workShop',
    {
      name: 'parentNode',
      note: '所属型号'
    }
  ],
  search: [
    'name'
    // 'parentNode'
  ],
  hooks: {
    beforeFetch ({ where }) {
      where.type = 'ratio'
      // where.workShop = { $exists: true }
      if (store.state.user && store.state.user.allShopManagements === 'Yes') {

      } else {
        where.workShop = {
          $in: store.state.user.shopManagements
        }
      }
    }
  },
  action: {
    delete: false,
    create: store.state.user && store.state.user.authority.proportion.create
      ? {
        title: '添加型号含量',
        component: editProportion
      } : false,
    edit: store.state.user && store.state.user.authority.proportion.edit
      ? {
        title: '编辑型号含量',
        component: editProportion
      } : false
  }
}
